import { injectTranslate } from '@core/i18n-legacy';
import { textCellFactory } from '@core/user-interface-legacy';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../offer-columns';

export const disqualifiedCountColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.DisqualifiedCount,
  label: injectTranslate()('app.offers.table.disqualified'),
  visible: false,
  geometry: {
    width: 120,
    minWidth: 120,
    maxWidth: 140,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: textCellFactory('disqualifiedCandidatesCount'),
}));
